import React from 'react';

// scss
import './Footer.scss';

type Props = {}

const Footer: React.FC<Props> = (props) => {

  return (
    <footer id="Footer">
      <div className="footerWrapper">
        <div className="footerRight">Copyright © 2020 KOKUYO Co.,Ltd. All rights reserved.</div>
      </div>
    </footer>
  );
}

export default Footer;
